import '../globals';
import { Carousel } from "bootstrap";

/**
 * Call carousel manually
 */
(function(PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function() {
        const carouselInner = document.querySelectorAll('.carousel .carousel-inner');

        if (carouselInner.length) {
            const carousels = document.querySelectorAll('.carousel');
            Array.from(carousels).forEach((carouselEl) => {
                const carousel = Carousel.getOrCreateInstance(carouselEl);
            });
        }
    });
})(window.PageLoadedQueue);
